import {
  CarOutlined,
  ScheduleOutlined,
  IdcardOutlined,
  MessageOutlined,
  FormOutlined,
} from "@ant-design/icons";

const cardData = [
  {
    title: "Travel Plan",
    description:
      "Add Schedule details with date, time, and route.\n" +
      "Sync with personal and office calendar.\n" +
      "Notify concerned persons/groups.\n" +
      "Manage vehicle and volunteer associations.",
    img: "https://www.arrivia.com/wp-content/uploads/2024/10/Close-up-of-a-digital-calendar-showcasing-the-integration-of-AI-technology-in-managing-smart-travel-itineraries-and-schedules-scaled.jpeg", 
    icon: <ScheduleOutlined />,
  },
  {
    title: "Transport",
    description:
      "Manage vehicle inventory.\n" +
      "Track movement with GPS.\n" +
      "Monitor driver details and whereabouts.\n" +
      "Assign leaders/volunteers.\n" +
      "Link transport with travel plans.",
    img: "https://www.360connect.com/wp-content/uploads/2021/01/shutterstock_1508611964-1-1024x576.jpg", 
    icon: <CarOutlined />,
  },
  {
    title: "Appointment",
    description:
      "Find and schedule availability.\n" +
      "Modify, cancel, or update appointments privately.\n" +
      "Send notifications to users.\n" +
      "Summarize daily appointments for leaders.\n" +
      "Add meeting minutes (MOM) with privacy settings.\n" +
      "Leaders can set their availability.",
    img: "https://cdn.prod.website-files.com/5f46c318c843828732a6f8e2/659bccd9030693d197b79fc8_digital-calendar.webp", 
    icon: <IdcardOutlined />,
  },
  {
    title: "Grievance Management",
    description:
      "Allow users to raise grievances via an open link with OTP verification.\n" +
      "Assign grievances to different levels.\n" +
      "Admins can monitor grievance summaries by category.\n" +
      "Track ticket status and highlight long-pending cases.\n" +
      "Trigger auto reminders for unresolved grievances.\n" +
      "Summarize resolved tickets for circulation.",
    img: "https://cdn.dribbble.com/userupload/16532126/file/original-88fd7cd5b40ffcfcf6f6b6bc6602fe8b.png?resize=400x0",
    icon: <MessageOutlined />,
  },
  {
    title: "Messaging & Survey",
    description:
      "Send personalized messages using templates.\n" +
      "Create survey links and collect responses.\n" +
      "View responses with detailed reports.",
    img: "https://images.prismic.io/getstream/Zmmnbpm069VX1rgi_hero-chat-messaging-product.png?auto=format,compress",
    icon: <FormOutlined />,
  },
];

export default cardData;
